export const DEFAULT_KICODE_URL: string =
  import.meta.env.VITE_KICODE_URL || '';
